const TOPICS = [
  { label: '流浪地球3', hot: '爆', color: 'accent' },
  { label: '封神第二部', hot: '热', color: 'primary' },
  { label: '大江大河3', hot: '热', color: 'primary' },
  { label: '狂飙2', hot: '新', color: 'secondary' },
  { label: '长相思2', hot: '热', color: 'primary' },
  { label: '庆余年3', hot: '新', color: 'secondary' },
  { label: '哪吒续集', hot: '新', color: 'secondary' },
  { label: '飘花电影网', hot: '荐', color: 'accent' },
  { label: '555电影', hot: '荐', color: 'accent' },
  { label: '8090电影网', hot: '荐', color: 'accent' },
  { label: '暑期档', hot: '热', color: 'primary' },
];

const HOT_COLORS: Record<string, string> = {
  accent: 'bg-accent-500/20 text-accent-400 border-accent-500/25',
  primary: 'bg-primary-500/15 text-primary-400 border-primary-500/25',
  secondary: 'bg-secondary-500/15 text-secondary-400 border-secondary-500/25',
};

const BADGE_COLORS: Record<string, string> = {
  accent: 'bg-accent-500 text-background-50',
  primary: 'bg-primary-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function SectionTopics() {
  return (
    <section id="topics" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            大家都在搜的热门影视话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <span
              key={topic.label}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium border cursor-pointer transition-all hover:scale-105 ${HOT_COLORS[topic.color]}`}
            >
              {topic.label}
              <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold leading-none ${BADGE_COLORS[topic.color]}`}>
                {topic.hot}
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}